import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KeHoachHangVe } from '../../../mua-hang/ke-hoach-hang-ve/ke-hoach-hang-ve-model/ke-hoach-hang-ve.model';

const API_ROOT_URL = environment.ApiRoot + '/muahang';

@Injectable()
export class KeHoachHangVeTTHVService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KeHoachHangVe_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	updateKeHoachHangVe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KeHoachHangVe>(API_ROOT_URL+'/CTDatHang_Update_SL', item, { headers: httpHeaders });
	}

	uploadFile(data): Observable<any> {
		const url = environment.ApiRoot + '/kho' + '/TTHV_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}

	listHangHoa() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Hang_Hoa_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}

	listState() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + `/TrangThaiPhieu_List?category=PTTHV` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}

	// listNV(IdPB: number) : Observable<any> {
	// 	const httpHeaders = this.httpUtils.getHTTPHeaders();
	// 	const url =  environment.ApiRoot + '/dungchung' + `/NhanVienPB_List?id=${IdPB}` ;
	// 	return this.http.get<any>(url , { headers: httpHeaders });
	// }

	listNV() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + `/DM_NhanVien_List` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
}
